var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.is_loaded
    ? _c(
        "div",
        { class: _vm.is_premium ? "pta-documents-premium" : "pta-documents" },
        [
          _c("h1", [_vm._v("Documents")]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-content-center" }, [
            _c("h2", [_vm._v("Upload your marketing materials")]),
            _vm._v(" "),
            _c("ul", { staticClass: "pta-uploads" }, [
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Fact Sheet")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "pta-ai-link",
                      attrs: { href: "/fs2/" + _vm.user_id_cur + "/pdf" },
                    },
                    [_vm._v("AI Generator")]
                  ),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 1,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Presentation")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "pta-ai-link",
                      attrs: { href: "/ps2/" + _vm.user_id_cur + "/pdf" },
                    },
                    [_vm._v("AI Generator")]
                  ),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Team Bios")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "pta-ai-link",
                      attrs: { href: "/bios2/" + _vm.user_id_cur + "/pdf" },
                    },
                    [_vm._v("AI Generator")]
                  ),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 3,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Case Studies")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 4,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("FAQ/DDQ")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 5,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Track Record")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 6,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Financial Model")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 7,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Key Terms")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 8,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Market Reports")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 9,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("h3", [_vm._v("Any other marketing materials")]),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c("file-upload-input", {
                        attrs: {
                          "button-text": "Choose file to upload",
                          token: _vm.upload_token,
                          module: "documents",
                          "clear-file": _vm.clear_message_attachment,
                          "module-id": 10,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }